import queryString from "query-string";
import React from "react";

export function RedirectBlank() {
  const queries = queryString.parse(window.location.search);
  const target = queries.target ? queries.target.toString() : "";
  window.location.replace(target);
  return <div></div>;
}
